import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { SavedSearchCommonDataService } from '@clubhub/ignite/services/saved-searches/saved-search-common-data.service';
import { SavedSearchesService } from '@clubhub/ignite/services/saved-searches/saved-searches.service';
import { SaveSearchModalComponent, SaveSearchModalResponse } from '@shared/components/save-search-modal/save-search-modal.component';
import { roles } from '@shared/constants';
import { AuthorizeService } from '../authorize.service';
import { ModalService } from '../modal.service';

function isRouteExcluded(url: string) {
  const excludedRoutes = [
    '/ignite/affordability/form/',
    '/ignite/products/form/',
    '/ignite/property/form/',
    '/ignite/criteriaV2/landing/',
  ];

  return excludedRoutes.some(r => url.startsWith(r));
}

export const unsavedChangesGuard: CanDeactivateFn<unknown> = async (_component, _currentRoute, currentState, nextState) => {
  // If navigating between excludedRoutes don't check for unsaved changes
  if (isRouteExcluded(currentState.url) && isRouteExcluded(nextState.url)) {
    return true;
  }

  const authService = inject(AuthorizeService);
  const savedSearchesService = inject(SavedSearchesService);
  const savedSearchCommonDataService = inject(SavedSearchCommonDataService);
  const modalService = inject(ModalService);

  if (authService.hasRole(roles.savedSearches) && savedSearchCommonDataService.unsavedChanges) {
    try {
      const res: SaveSearchModalResponse | undefined = await modalService
        .open({
          title: 'Unsaved Search',
          component: SaveSearchModalComponent,
          data: {
            openedAutomatically: true,
          },
        });

      if (res) {
        await savedSearchesService.saveSearchDetails(res.searchName);
      } else {
        // Clear the unsaved changes when navigating away to prevent the browser popup
        // when the user has already discarded the changes using the custom modal.
        savedSearchCommonDataService.reset();
      }

      return true;

    } catch {
      return false;
    }
  }

  return true;
};
